import { Box } from '@mui/material'
import { inject, observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import DataUnit from '../../../../../components/customElements/DataUnit/DataUnit'
import FormInput from '../../../../../components/customElements/FormInput'
import CustomAccordion from '../../../../../components/customElements/RequestDataAccordions/utils/CustomAccordion'
import { useGetReceiverModels } from '../../../../../hooks/useGetReceiverModels'
import { isAdmin, isDealer } from '../../../../../services/AccountService'

const FullEquipmentDataAccordion = ({ serviceStore, isEditable }) => {
  const intl = useIntl()
  const { currentServiceData, serviceInformationAccordionFormStore } =
    serviceStore
  const { data: serviceReceivers } = useGetReceiverModels()
  const [isEdit, setIsEdit] = useState(false)

  useEffect(() => {
    serviceInformationAccordionFormStore.data.orderId = currentServiceData.id
  }, [])

  const handleEdit = () => {
    setIsEdit((prev) => !prev)
  }

  return (
    <CustomAccordion
      summary={'Данные оборудования'}
      defaultOpenState={true}
      preventHandleOpen={false}
    >
      <Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '14px',
            marginTop: '12px',
            paddingLeft: '10px',
          }}
        >
          {isEditable ? (
            <>
              <DataUnit
                sx={{ marginBottom: '2px' }}
                name='Id оборудования'
                value={currentServiceData.equipmentId || 'Не заполнен'}
              />
              {isDealer() || isAdmin() ? null : (
                <Box>
                  <FormInput
                    type='select'
                    api={serviceInformationAccordionFormStore}
                    propName={'receiverModelId'}
                    label={intl.formatMessage({ id: 'Модель оборудования' })}
                    fullWidth
                    placeholder={'Модель оборудования'}
                    items={serviceReceivers.map((el) => ({
                      key: `${el.name} - ${el.manufacturerName}`,
                      value: el.id,
                    }))}
                    withoutErrorText={true}
                  />
                  <FormInput
                    type='text'
                    api={serviceInformationAccordionFormStore}
                    propName={'receiverSerialNumber'}
                    label={intl.formatMessage({ id: 'Серийный номер' })}
                    fullWidth
                    placeholder={'Серийный номер'}
                    withoutErrorText={true}
                  />
                </Box>
              )}
            </>
          ) : (
            <>
              <DataUnit
                name='Id оборудования'
                value={currentServiceData.equipmentId || 'Не заполнен'}
              />
              {!isDealer() && !isAdmin() && (
                <>
                  <DataUnit
                    name='Модель оборудования'
                    value={
                      currentServiceData.receiverProduct ||
                      currentServiceData.primaryReceiverProduct ||
                      'Не заполнен'
                    }
                  />
                  <DataUnit
                    name='Серийный номер'
                    value={
                      currentServiceData.receiverSerialNumber || 'Не заполнен'
                    }
                  />
                </>
              )}
            </>
          )}
        </Box>
      </Box>
    </CustomAccordion>
  )
}

export default inject('serviceStore')(observer(FullEquipmentDataAccordion))
